import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerReports } from "../graphql/queries";
import { ReportCard } from "../components/ReportCard";

const client = generateClient();

const getReportDate = (report) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 =
      typeof report.ef1 === "string" ? JSON.parse(report.ef1) : report.ef1;

    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(report.date || 0);
  } catch (error) {
    console.error(`Error parsing date for report item:`, report);
    return new Date(report.date || 0);
  }
};

export function Reports(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerReports,
      });

      // Sort report items by date, newest first
      const sortedReportItems = pendingData["data"][
        "listSlumSoccerReports"
      ].items.sort((a, b) => {
        const dateA = getReportDate(a);
        const dateB = getReportDate(b);
        return dateB - dateA; // Newest first
      });

      setData(sortedReportItems);
    } catch (error) {
      console.error("Error fetching or sorting report items:", error);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
      <div className="container mx-auto px-9">
        <div className="text-center mb-5">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5 ">
            Reports
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.map((report) => (
            <ReportCard key={report.reportId} report={report} />
          ))}
        </div>
      </div>
    </section>
  );
}